import { Code2 } from "lucide-react";
import { Section, SectionHeading, PageHero } from "../components/site/section";
import { PageCta } from "../components/site/page-cta";

const docs = [
    { title: "Ingestion pipelines", body: "How each agency dataset is fetched, deduplicated, matched to a building and published." },
    { title: "Data dictionary", body: "Field-level definitions for every normalized record type, with agency source mappings." },
    { title: "REST API", body: "Authenticated endpoints for properties, violations, filings and history, with cursor pagination." },
    { title: "Webhooks", body: "Subscribe to new records by property or class and receive signed JSON payloads." },
];
function InfraCode() {
    return (<>
      <PageHero eyebrow="Infra code & API" title="Built to be built on." description="If your team would rather have the data in their own stack, take it."/>
      <Section>
        <SectionHeading eyebrow="Documentation" title="What's documented"/>
        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {docs.map((d) => (<div key={d.title} className="rounded-xl border border-border bg-card p-7 shadow-card">
              <Code2 className="h-5 w-5 text-accent"/>
              <h2 className="mt-5 text-lg font-semibold">{d.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{d.body}</p>
            </div>))}
        </div>
      </Section>
      <PageCta />
    </>);
}

export default InfraCode;
